import { render, staticRenderFns } from "./M3m_S28.vue?vue&type=template&id=6642ff3c&scoped=true"
import script from "./M3m_S28.vue?vue&type=script&lang=js"
export * from "./M3m_S28.vue?vue&type=script&lang=js"
import style0 from "./M3m_S28.vue?vue&type=style&index=0&id=6642ff3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6642ff3c",
  null
  
)

export default component.exports